goog.provide("shadow.js.shim.module$$tiptap$extension_text_style");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_text_style");
shadow.js.shim.module$$tiptap$extension_text_style = shadow.js.nativeProvides["@tiptap/extension-text-style"] = shadow$bridge("@tiptap/extension-text-style");
module$shadow_js_shim_module$$tiptap$extension_text_style.default = shadow.js.shim.module$$tiptap$extension_text_style;
